import { render, staticRenderFns } from "./OsLogoUploader.vue?vue&type=template&id=61b99e0a&scoped=true"
import script from "./OsLogoUploader.vue?vue&type=script&lang=ts"
export * from "./OsLogoUploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b99e0a",
  null
  
)

export default component.exports